import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`accounts-payable-accountant/payment-postings?${query}`)
  },

  async show (id) {
    return ApiService.get(`accounts-payable-accountant/payment-postings/${id}`)
  },

  async post (payload) {
    return ApiService.post('accounts-payable-accountant/payment-postings', payload)
  },

  async put (payload) {
    return ApiService.put(`accounts-payable-accountant/payment-postings/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`accounts-payable-accountant/payment-postings/${payload.id}`)
  }
}

export default PendingService
